// extracted by mini-css-extract-plugin
module.exports = {"proposalRow":"TibBannerTable_proposalRow_2ihDd"};